import * as React from 'react';
var File = function (_a) {
    var title = _a.title, titleId = _a.titleId;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fill: "evenodd", d: "M15.3 4l-1.1-1H5v18h14V7.6L15.3 4zM7 19V5h6.3v4H17v10H7z" }),
        React.createElement("path", { fill: "evenodd", d: "M8 7h4v2H8zM8 11h8v2H8zM8 15h8v2H8z" })));
};
export default File;
//# sourceMappingURL=File.js.map